import { http } from "./http.js";

export interface HandshakeRequest {
  app_token: string;
  user_id: string;
  tenant_key?: string;
}

export interface HandshakeNeedsSetup {
  needs_setup: true;
  setup_token: string;
}

export interface HandshakeReady {
  needs_setup: false;
  install_id: string;
  session_token: string;
  display_name: string;
  enabled_platforms: string[];
  has_pat: boolean;
  has_robot_webhook: boolean;
}

export type HandshakeResponse = HandshakeNeedsSetup | HandshakeReady;

export async function handshake(input: HandshakeRequest): Promise<HandshakeResponse> {
  const res = await http.post<HandshakeResponse>("/auth/handshake", input);
  return res.data;
}
